import React, { useEffect, useState } from "react"
import styles from "./LeanCanvas.module.css"
import { fetchLeanCanvasData } from "./Utils/fetchLeanCanvasData"
import { AIProject, FieldDescriptions } from "./Model/types"
import { makeAIProjects } from "./Model/makeAIProjects"
import ProjectList from "./Components/ProjectList"
import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import ProjectDetails from "./Components/ProjectDetails"

export interface LeanCanvasProps {}

export const dataUpdate = {
    onDataUpdate: () => {},
}

const LeanCanvas: React.FC<LeanCanvasProps> = ({}) => {
    const [projects, setProjects] = useState<AIProject[] | null>(null)
    const [expectedBenefitsData, setExpectedBenefitsData] = useState<any>(null)
    const [fieldDescriptions, setFieldDescriptions] = useState<FieldDescriptions>({})
    const [endCustomersData, setEndCustomersData] = useState<any>(null)
    const [businessValueData, setBusinessValueData] = useState<any>(null)
    const navigate = useNavigate()
    const location = useLocation()

    const getData = async () => {
        const projectsTableId = "tblBHvL0hF6VvSiTg"
        const viewId = "viw1oTpQjxf5dAKfC"
        const projectsData = await fetchLeanCanvasData(projectsTableId, viewId)
        // console.log("🚀 ~ getData ~ projectsData:", projectsData)

        const expectedBenefitsTableId = "tblhK9D1ReybxVSSU"
        const expectedBenefitsData = await fetchLeanCanvasData(expectedBenefitsTableId)
        // console.log("🚀 ~ getData ~ expectedBenefitsData:", expectedBenefitsData)
        setExpectedBenefitsData(expectedBenefitsData)

        const fieldDescriptionsTableId = "tblexSljqcSjCe1VO"
        const fieldDescriptionsData = await fetchLeanCanvasData(fieldDescriptionsTableId)
        // console.log("🚀 ~ getData ~ fieldDescriptionsData:", fieldDescriptionsData)
        setFieldDescriptions(fieldDescriptionsData[0].fields)

        const endCustomersTableId = "tbllm0AeXGcWBZHec"
        const ecData = await fetchLeanCanvasData(endCustomersTableId)
        // console.log("🚀 ~ getData ~ endCustomersData:", ecData)
        setEndCustomersData(ecData)

        const businessValueTableId = "tbldEZDxwzgCByKqH"
        const bvData = await fetchLeanCanvasData(businessValueTableId)
        // console.log("🚀 ~ getData ~ businessValueData:", bvData)
        setBusinessValueData(bvData)

        setProjects(makeAIProjects(projectsData, expectedBenefitsData, ecData, bvData))
    }

    dataUpdate.onDataUpdate = () => {
        getData()
    }

    useEffect(() => {
        document.title = "AI Lean Canvas"
        getData()
    }, [])

    const selectProject = (project: AIProject) => {
        navigate(`?project=${project.id}&edit=true`)
    }

    const onDataUpdate = () => {
        getData()
    }

    const loadingView = <div className={styles.loading}>loading data...</div>
    const projectList = projects ? <ProjectList projects={projects} selectProject={selectProject} /> : loadingView

    const params = new URLSearchParams(location.search)
    const selectedProjectId = params.get("project")

    const selectedProject =
        selectedProjectId && projects
            ? projects.find((project) => {
                  return project.id === selectedProjectId
              })
            : undefined

    const content = selectedProject ? <ProjectDetails project={selectedProject} expectedBenefitsData={expectedBenefitsData} endCustomersData={endCustomersData} businessValueData={businessValueData} onDataUpdate={onDataUpdate} fieldDescriptions={fieldDescriptions} /> : projectList

    return (
        <div className={styles.leanCanvas} id="lean-canvas">
            <Routes>
                <Route path="/" element={content} />
            </Routes>
        </div>
    )
}

export default LeanCanvas

// return (
//     <PasswordProtected>
//         <div className={styles.leanCanvas} id="lean-canvas">
//             <Routes>
//                 <Route path="/LeanCanvas/" element={content} />
//             </Routes>
//         </div>
//     </PasswordProtected>
// )
